/**
 * PixelArtPlayer — wraps HtmlBridgePlayer with the Pixel Quest theme
 * pre-loaded as a blob URL. No external URL required; the HTML is bundled
 * inline. Works on web only (inherits the bridge's native placeholder).
 */

import {useEffect, useRef, useState} from 'react'

import {HtmlBridgePlayer} from '#/themes/html-bridge/HtmlBridgePlayer'
import {type ThemePlayerProps} from '#/types/capsule'
import {PIXEL_ART_HTML} from './pixel-art-html'

export function PixelArtPlayer(props: ThemePlayerProps) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null)
  const blobRef = useRef<string | null>(null)

  useEffect(() => {
    if (typeof URL === 'undefined' || typeof Blob === 'undefined') return
    const blob = new Blob([PIXEL_ART_HTML], {type: 'text/html'})
    const url = URL.createObjectURL(blob)
    blobRef.current = url
    setBlobUrl(url)
    return () => {
      if (blobRef.current) URL.revokeObjectURL(blobRef.current)
    }
  }, [])

  if (!blobUrl) return null

  // Inject blob URL into behaviorSettings so HtmlBridgePlayer auto-loads it
  const enriched: ThemePlayerProps = {
    ...props,
    capsule: {
      ...props.capsule,
      behaviorSettings: {
        ...(props.capsule.behaviorSettings ?? {}),
        htmlThemeUrl: blobUrl,
      },
    },
  }

  return <HtmlBridgePlayer {...enriched} />
}
